import '../biotrust/cart';
$(function () {
  // unset flag that keeps precheckout upsell open when device rotates #KLUDGE
  window.localStorage.removeItem('bt.preCheckoutUpsell.open');
});